import { call, put, takeEvery } from 'redux-saga/effects';
import { AddContentFavoriteAction, RemoveContentFavoriteAction, SearchActionTypes } from '../actions/ActionTypes';
import { SagaIterator } from 'redux-saga';
import { ContentService } from '../services/ContentService';
import { SearchResultItem } from '../models/SearchResultTypes';
import { contentFavoriteAdded, contentFavoriteRemoved } from '../actions/FavoritesAction';

export function* rootFavoritesSaga(): SagaIterator {
  yield takeEvery(SearchActionTypes.ADD_CONTENT_FAVORITE_ACTION, handleAddContentFavorite);
  yield takeEvery(SearchActionTypes.REMOVE_CONTENT_FAVORITE_ACTION, handleRemoveContentFavorite);
}

export function* handleAddContentFavorite(action: AddContentFavoriteAction) {
  try {
    yield call(addFavorite, action.item);
    yield put(contentFavoriteAdded(action.item));
  } catch (e) {
    // yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function addFavorite(item: SearchResultItem): Promise<void> {
  return ContentService.instance.addFavorite(item);
}

export function* handleRemoveContentFavorite(action: RemoveContentFavoriteAction) {
  try {
    yield call(removeFavorite, action.item);
    yield put(contentFavoriteRemoved(action.item));
  } catch (e) {
    // yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function removeFavorite(item: SearchResultItem): Promise<void> {
  return ContentService.instance.removeFavorite(item);
}
